<template>
<div class="literacy-main">
  <div class="literacy-main-content">
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="close">
      </div>
      <div class="header-card-text">
        <h3>Risk Profile</h3>
        <p class="secondary">Kindly take this assessment to help us know which Investment
        Opportunities to Recommend</p>
      </div>
    </div>
    <literacy-component-1 v-if="current == 0" @next="next" @previous="previous">
    </literacy-component-1>
    <literacy-component-2 v-if="current == 1" @next="next" @previous="previous">
    </literacy-component-2>
    <literacy-component-3 v-if="current == 2" @next="next" @previous="previous">
    </literacy-component-3>
    <literacy-component-4 v-if="current == 3" @next="next" @previous="previous">
    </literacy-component-4>
    <literacy-component-5 v-if="current == 4" @next="next" @previous="previous">
    </literacy-component-5>
    <literacy-component-6 v-if="current == 5" @next="next" @previous="previous">
    </literacy-component-6>
    <!-- <literacy-component-7 v-if="current == 6" @next="next" @previous="previous">
    </literacy-component-7> -->
    <risk-profile v-if="showSuccess" @close="closePrompt" :message="riskProfile"></risk-profile>
     <!-- <success-component v-if="showSuccess" @close="closePrompt" :message="successMsg">
     </success-component> -->
  </div>
</div>
</template>

<script>
// import axios from 'axios';

import LiteracyComponent1 from '../components/LiteracyComponent1.vue';
import LiteracyComponent2 from '../components/LiteracyComponent2.vue';
import LiteracyComponent3 from '../components/LiteracyComponent3.vue';
import LiteracyComponent4 from '../components/LiteracyComponent4.vue';
import LiteracyComponent5 from '../components/LiteracyComponent5.vue';
// import SuccessComponent from '../components/Success.vue';
import LiteracyComponent6 from '../components/LiteracyComponent6.vue';
import RiskProfile from '../components/RiskProfiles.vue';
// import LiteracyComponent7 from '../components/LiteracyComponent7.vue';

export default {
  components: {
    LiteracyComponent1,
    LiteracyComponent2,
    LiteracyComponent3,
    LiteracyComponent4,
    LiteracyComponent5,
    // SuccessComponent,
    LiteracyComponent6,
    RiskProfile,
    // LiteracyComponent7,
  },
  data() {
    return {
      current: 0,
      literacyData: {},
      tempData: {},
      showSuccess: false,
      riskProfile: '',
      userProfiles: [
        'Risk Averse',
        'Conservative',
        'Moderate',
        'Moderately Aggressive',
        'Aggressive',
        'Very Aggressive',
      ],
    };
  },
  methods: {
    async next(e) {
      // console.log(e);
      this.literacyData = { ...this.literacyData, ...e };
      if (this.current < 5) {
        this.current += 1;
      } else {
        try {
          const url = `${this.$baseUrl}/assessment/add`;
          const res = await this.$http({ url, data: this.literacyData, method: 'POST' });
          const riskAppetite = res.data.risk_appetite;
          this.riskProfile = this.userProfiles[riskAppetite - 1];
          localStorage.setItem('risk_appetite', riskAppetite);
          this.showSuccess = true;
          setTimeout(() => {
            // this.closePrompt();
          }, 5000);
          // console.log(res.data);
        } catch (error) {
          console.log(error);
        }
      }
    },
    previous() {
      if (this.current > 0) {
        this.current -= 1;
      } else {
        // Stop moving
      }
    },
    close() {
      this.$emit('close');
    },
    closePrompt() {
      this.showSuccess = false;
      this.close();
    },
  },
};
</script>

<style scoped>
  .literacy-main-content{
    position: absolute;
    top: 0;
    background-color: #F9F9F9;
    z-index: 2;
  }
</style>
